import React from "react";
import { Typography } from "antd";
import IRLOGO from "../../../assets/images/icon/logo-icon.png";
import styles from "./AuthHero.module.css";

const { Title, Paragraph } = Typography;

export interface BenefitItem {
  title: string;
  desc: string;
}

export interface AuthHeroProps {
  mainTitle: string;
  instantly: string | null;
  subtitle: string;
  benefits?: BenefitItem[];
  logoSrc?: string;
  logoAlt?: string;
  className?: string;
}

export const AuthHero: React.FC<AuthHeroProps> = ({
  mainTitle,
  instantly,
  subtitle,
  benefits = [],
  logoSrc = IRLOGO,
  logoAlt = "Company Logo",
  className = "",
}) => {
  return (
    <div className={`${styles.heroSection} ${className}`}>
      <div className={styles.heroContent}>
        <img src={logoSrc} alt={logoAlt} className={styles.heroLogo} />

        <p  className={styles.heroMainTitle}>
          {mainTitle} <span className= {styles.instantly}> {instantly}</span>
        </p>

        <Paragraph className={styles.heroSubtitle}>{subtitle}</Paragraph>

        {benefits.length > 0 && (
          <div className={styles.benefitsSection}>
            <div className={styles.benefitsGrid}>
              {benefits.map((item, idx) => (
                <div key={idx} className={styles.benefitCard}>
                  <span className={styles.benefitTitle}>{item.title}</span>
                  <span className={styles.benefitDesc}>{item.desc}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};